"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ContentHelpfulnessManager = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _ConfigurationPanel = _interopRequireDefault(require("./ConfigurationPanel"));

var _ContentHelpfulnessPreview = _interopRequireDefault(require("./ContentHelpfulnessPreview"));

var _header = _interopRequireDefault(require("../header"));

var _Alert = _interopRequireDefault(require("../ui-components/Alert"));

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ContentHelpfulnessManager = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ContentHelpfulnessManager, _Component);

  var _super = _createSuper(ContentHelpfulnessManager);

  function ContentHelpfulnessManager(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ContentHelpfulnessManager);
    _this = _super.call(this, props);
    var visibility = {
      visibility: Object.assign({}, _this.getDefaultState().visibility, props.configuration.visibility)
    };
    _this.state = Object.assign({}, _this.getDefaultState(), {
      indicator: props.configuration.indicator
    }, visibility, props.phrases);
    _this.saveUri = '/helpfulness/configuration';
    _this.phraseUri = '/phrase/edit';
    _this.phrases = {
      defaultMessage: {
        key: 'topic.helpfulness.text',
        value: props.phrases.defaultMessage
      },
      successMessage: {
        key: 'topic.helpfulness.thanks',
        value: props.phrases.successMessage
      },
      indicatorLabel: {
        key: 'topic.helpfulness.indicator',
        value: props.phrases.indicatorLabel
      }
    };
    return _this;
  }

  (0, _createClass2.default)(ContentHelpfulnessManager, [{
    key: "getDefaultState",
    value: function getDefaultState() {
      return {
        indicator: false,
        visibility: {
          answers: false,
          articles: false,
          questions: false,
          discussions: false
        }
      };
    }
  }, {
    key: "save",
    value: function save() {
      var _this2 = this;

      var data = {
        indicator: this.state.indicator,
        visibility: this.state.visibility
      };
      this.sendXHRequest(data);
      var updatedPhrases = Object.keys(this.phrases).filter(function (phrase) {
        return _this2.phrases[phrase].value !== _this2.state[phrase];
      });
      updatedPhrases.forEach(function (phrase) {
        var phraseData = {
          category: 'Forum',
          message: _this2.phrases[phrase].key,
          translation: _this2.state[phrase]
        };

        _this2.updatePhrase(phraseData);
      });
    }
  }, {
    key: "sendXHRequest",
    value: function sendXHRequest(data) {
      var _this3 = this;

      var xhr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new window.XMLHttpRequest();
      xhr.addEventListener('readystatechange', function (e) {
        return _this3.onReadyStateChangeHandler(e);
      }, false);
      xhr.open('POST', (0, _absoluteUrlRuntime.resolveUrl)(this.saveUri), true);
      xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
      xhr.setRequestHeader('X-Csrf-Token', document.getElementById('csrftoken').value);
      xhr.send(JSON.stringify(data));
    }
  }, {
    key: "updatePhrase",
    value: function updatePhrase(data) {
      var _this4 = this;

      var xhr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new window.XMLHttpRequest();
      var queryParam = Object.keys(data).reduce(function (currentVal, key) {
        return "".concat(currentVal).concat(key, "=").concat(data[key], "&");
      }, '?');
      queryParam = queryParam.substring(0, queryParam.length - 1);
      xhr.addEventListener('readystatechange', function (e) {
        return _this4.onReadyStateChangeHandler(e);
      }, false);
      xhr.open('GET', (0, _absoluteUrlRuntime.resolveUrl)(this.phraseUri + queryParam), true);
      xhr.send();
    }
  }, {
    key: "onReadyStateChangeHandler",
    value: function onReadyStateChangeHandler(evt) {
      if (evt.target.readyState === 4) {
        if (evt.target.status === 200) {
          this.props.successCallback();
        } else {
          this.props.errorCallback();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var props = this.props;
      var state = this.state;
      var configuration = state;
      var phrases = {
        'topic.helpfulness.text': configuration.defaultMessage,
        'topic.helpfulness.thanks': configuration.successMessage,
        'topic.helpfulness.indicator': configuration.indicatorLabel
      };
      return (0, _preact.h)("div", null, (0, _preact.h)(_header.default, {
        title: 'Content Helpfulness',
        saveCallback: function saveCallback() {
          return _this5.save();
        }
      }), props.alertComponent, (0, _preact.h)("div", {
        className: 'content-helpfulness-manager'
      }, (0, _preact.h)(_ConfigurationPanel.default, {
        configuration: configuration,
        updatePhrase: function updatePhrase(key, value) {
          return _this5.setState((0, _defineProperty2.default)({}, key, value));
        },
        setValue: function setValue(value, field) {
          return _this5.setState((0, _defineProperty2.default)({}, field, value));
        },
        setIndicator: function setIndicator() {
          return _this5.setState({
            indicator: !configuration.indicator
          });
        },
        setVisibility: function setVisibility(visibility) {
          return _this5.setState({
            visibility: Object.assign({}, _this5.state.visibility, visibility)
          });
        }
      }), (0, _preact.h)("div", {
        className: "content-helpfulness_preview"
      }, (0, _preact.h)(_ContentHelpfulnessPreview.default, {
        phrases: phrases,
        showIndicator: configuration.indicator
      }))));
    }
  }]);
  return ContentHelpfulnessManager;
}(_preact.Component);

exports.ContentHelpfulnessManager = ContentHelpfulnessManager;

var _default = function _default(props) {
  return (0, _preact.h)(_Alert.default, (0, _extends2.default)({}, props, {
    component: ContentHelpfulnessManager
  }));
};

exports.default = _default;